export const APP_STORE_BADGES = {
  play_store_badge_PT:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/8630c124-ec55-4d06-11b6-40197d8b3b00/public",
  play_store_badge_IT:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/0347fd05-3225-41f3-8ca0-0bc1cac2b600/public",
  play_store_badge_ES:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/cea76ebd-4295-40d5-b907-a2f74e833500/public",
  play_store_badge_PL:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/258d1da4-1e1f-4616-38e6-f69fecbcea00/public",
  play_store_badge_EN:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/55034c61-30ee-4651-2370-e0201834b200/public",
  play_store_badge_DE:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/935ea528-eda9-4f24-386d-f24af3a92e00/public",
  play_store_badge_UK:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/e205d96b-9b4b-4dce-b9e3-7eadac3f8900/public",
  play_store_badge_FR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/1a5d8838-99ad-4279-9ed1-9d59d0de8c00/public",
  play_store_badge_AR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/58cfd2ad-6f6b-463f-fc52-0f479289f700/public",
  play_store_badge_TR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/dd0b559a-8df5-40ab-311c-66b83e22b900/public",
  play_store_badge_NL:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/aba84ac4-6252-4974-4604-2d4e6a526b00/public",
  play_store_badge_HI:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/8d82c8c0-9aa1-462b-4c13-eb11c00a3200/public",
  app_store_badge_TR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/ebed67b9-645f-4876-8b16-af5214f6b900/public",
  app_store_badge_EN:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/065ef0e6-b936-47d4-d836-548009668300/public",
  app_store_badge_FR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/632ba9b5-927e-471e-3cb0-167bb33f6200/public",
  app_store_badge_DE:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/5e31f176-41b7-47db-dcfe-7b578d91a400/public",
  app_store_badge_NL:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/a1a5f1ba-f38a-4402-bb5d-96e499bd3a00/public",
  app_store_badge_ES:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/60ff907b-5bb0-49b2-3af0-a48ac7aab100/public",
  app_store_badge_PT:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/cdc6c916-6e82-4486-9db5-6d59e9c05500/public",
  app_store_badge_IT:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/d092fe60-7e69-488f-b272-0ad666ee1d00/public",
  app_store_badge_AR:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/c889f42b-54e6-41cc-6bab-3e3e33621300/public",
  app_store_badge_UK:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/c7958771-3b9e-47be-a256-fe8d7a4ff800/public",
  app_store_badge_HI:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/9fd0c724-beb8-433c-cdc6-41b40f85c700/public",
  app_store_badge_PL:
    "https://img.taalia.com/cdn-cgi/imagedelivery/D0NzeBGnF4olmTi4zMGzIA/e10c18bf-9f1e-4e67-5b1a-d2305c634200/public",
};
